import '../../vendor/jquery.magnific-popup-update.js'

import {
	disableOuibounceForNormal,
	enableOuibounceForNormal,
	saveSeatingChartSize,
} from '../utils/func.js'
import getSeatWidgetImage from '../utils/get-seat-widget-image.js'
import getSeatWidgetImageBv from '../utils/get-seat-widget-image-bv.js'
import { htmlDecode } from '../utils/html-decode.ts'

// import twoWayBinding from '../components/two-way-binding'
import copyToClipboard from '../utils/copy-to-clipboard.js'

export const seatingChartWidth = window.chartVars.chartWidth
export const seatingChartHeight = window.chartVars.chartHeight

let previewEmailIsOpened = false
let shareSeatPopupIsInitialized = false

window.pageLinkCreated = false

function setEmailSubject() {
	const preSubject = $('#hidden-email-subject').data('value')
	const name = $('#ss-name-form').val()
	let subject
	if (name) {
		subject = `${name} ${preSubject}`
		$('#hidden-email-subject').val(subject)
	}
}

export function initShareSeatPopup(
	getSeatWidgetFn,
	isReviewCartPage,
	isBestAvailablePage
) {
	$('#share-seat-popup')
		.on('shown.bs.modal', () => {
			// getSeatWidgetImage(isReviewCartPage)
			if (isBestAvailablePage) {
				getSeatWidgetFn()
			} else {
				getSeatWidgetFn(isReviewCartPage)
			}

			sendSeatSelectionsToGetDirectLink()
			saveSeatingChartSize()
			$('[data-active-box=1]').fadeOut()
			// triggerTextarea()
			emailFormOnclick()
			disableOuibounceForNormal()
		})
		.on('hidden.bs.modal', () => {
			if (previewEmailIsOpened) {
				$('[data-active-box=1]').fadeOut()
			} else {
				$('[data-active-box=1]').fadeIn()
			}

			enableOuibounceForNormal()
		})
}

export function shareSeatPopup(
	getSeatWidgetFn,
	isReviewCartPage,
	isBestAvailablePage,
) {
	if (!shareSeatPopupIsInitialized) {
		initShareSeatPopup(getSeatWidgetFn, isReviewCartPage, isBestAvailablePage)
		shareSeatPopupIsInitialized = true
	}
	if (window.grecaptcha) {
		grecaptcha.reset();
	}
	$('#share-seat-popup').modal({
		show: true,
	})
}

function sendSeatSelections(dataType, postUrl, returnFunc, loadingFunc) {
	return new Promise((resolve, reject) => {
		if (loadingFunc) loadingFunc()
		// const form = document.querySelector('.ss-your-message-form')
		const postData = $('.ss-your-message-form').serialize()
		// if (!form?.checkValidity()) reject()
		$.ajax({
			url: postUrl,
			// type: 'POST',
			data: postData,
			dataType,
			cache: false,
			timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
			success(data, textStatus, xhr) {
				// submitData = decodeURI($(data).serialize())
				// console.info(postData)
				// console.info(data)
				if (returnFunc) {
					returnFunc(data, resolve, reject)
				} else {
					resolve()
				}
			},
			error(jqXHR, textStatus, errorThrown) {
				if (textStatus === 'timeout') {
					// console.info('timeout error')
					alert(myvars.timeoutErrorWhileTicketing) // Handle the timeout
					// window.location.reload(true)
				} else {
					// console.info('server error')
					alert(myvars.serverError) // Handle other error type
					// window.location.reload(true)
				}

				reject(errorThrown)
			},
		})
	})
}

function sendSeatSelectionsReturn(jsonResult, resolve, reject) {
	if (jsonResult.status === 1) {
		$('#share-seat-popup').modal('hide')
		resolve(window.myvars.seatSelectionsSaved)
	} else {
		alert(jsonResult.message ?? window.myvars.errorSavingSeat)
		reject(window.myvars.errorSavingSeat)
	}
}

function btnLoading() {
	$('.share-seat-submit').addClass('btn--loading')
}

// 格式化邮箱地址：将逗号转换为逗号+空格
function formatEmailValue(emailValue) {
	if (!emailValue) return emailValue
	// 将所有逗号后面没有空格的地方添加空格
	return htmlDecode(emailValue.replace(/,(?!\s)/g, '<br>'))
}

export function sendSeatSelectionsAction() {
	const postUrl = '/store/saved-seats/create'
	if (!validForm()) return false
	sendSeatSelections(
		'json',
		postUrl,
		sendSeatSelectionsReturn,
		btnLoading
	).then(
		(value) => {
			// alert(value)
			$('#share-seat-msg-holder')
				.on('shown.bs.modal', () => {
					$('[data-active-box=1]').fadeOut()
				})
				.on('hide.bs.modal', () => {
					$('[data-active-box=1]').fadeIn()
				})
				.modal({
					show: true,
				})

			$('.share-seat-submit').removeClass('btn--loading')
			const emailBox = document.querySelector('.confirmBox__email')
			const emailField = document.querySelector('#ss-email-form')
			if (emailBox && emailField) emailBox.innerHTML = formatEmailValue(emailField.value)
		},
		(errorThrown) => {
			$('.share-seat-submit').removeClass('btn--loading')
			console.info('sendSeatSelections errorThrown: ' + errorThrown)
			// alert(errorThrown)
		}
	)
}

function getDirectLinkReturn(jsonResult, resolve, reject) {
	if (jsonResult.status == 0) {
		// var errorMsg = jsonResult['message']
		// if (callback) callback()
		reject()
	} else {
		const { link } = jsonResult
		resolve(link)
	}
}

function sendSeatSelectionsToGetDirectLink() {
	const postUrl = '/store/saved-seats/create/getlink/1'
	// const discount = getUrlParameter('discount')
	// if (!pageLinkCreated) {
	sendSeatSelections('json', postUrl, getDirectLinkReturn).then(
		(value) => {
			// const url = discount ? `${value}?discountcode=${discount}` : value
			// console.info(url)
			$('#copy-direct-link-target').val(value)
			$('#copy-direct-link-btn').removeClass('disabled')
			// copyOnclick()
			// pageLinkCreated = true
		},
		(errorThrown) => {
			console.info('GetDirectLink errorThrown: ' + errorThrown)
			// console.info(errorThrown)
			// pageLinkCreated = false
		}
	)
	// }
}

export function copyOnclick(itemId, inputId = 'copy-direct-link-target') {
	const targetInput = document.getElementById(inputId)
	copyToClipboard(targetInput)
	$(itemId).attr('data-original-title', 'copied!').tooltip('show')
	if ($('.share-seat-info').is(':visible')) {
		$.ajax({
			url:
				'/promotion/campaign/update-impression?eid=tb-send-seats&event=' +
				window.myvars.eventId,
			// type: 'POST',
			cache: false,
			timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
			success(data, textStatus, xhr) {},
		})
	}
}

function peviewEmailReturn(data, resolve, reject) {
	// $('#share-seat-popup').modal('hide')
	// console.info(encodeURIComponent(jsonResult))
	if (data !== undefined) {
		// var emailHtml = $(data).find('#display-email-template').html()
		// $('#save-seats-email-placeholder').html(html)
		// console.info('data: ' + data)
		resolve(data)
	} else {
		reject()
	}
}

function emailFormOnclick() {
	$('[name=name]').on({
		blur() {
			// validForm()
			setEmailSubject()
		},
		keyup() {
			// validForm()
			setEmailSubject()
		},
	})

	$('[name=emailReceived]').on({
		focus() {
			// validForm()
			setEmailSubject()
		},
		blur() {
			// validForm()
			setEmailSubject()
		},
		keyup() {
			// validForm()
			setEmailSubject()
		},
		keydown() {
			// validForm()
			setEmailSubject()
		},
	})
}

function validForm() {
	const form = document.querySelector('.ss-your-message-form')
	if (form?.checkValidity()) {
		// $('.share-seat-preview, .share-seat-submit').removeClass('disabled')
		form.classList.add('was-validated')
		return true
	}

		// $('.share-seat-preview, .share-seat-submit').addClass('disabled')
		form.classList.add('was-validated')
		return false

}

// onclick "preview" button
export function previewEmailPost() {
	const postUrl = '/store/saved-seats/preview-email'
	sendSeatSelections('html', postUrl, peviewEmailReturn).then(
		(value) => {
			previewEmailAjax(value)
		},
		(errorThrown) => {
			alert(errorThrown)
		}
	)
}

function previewEmailAjax(value) {
	$('#save-seats-email-placeholder').html(value)
	// window.pageLinkCreated = false
	sendSeatSelectionsToGetDirectLink()
	$.magnificPopup.open({
		items: {
			src: '#save-seats-email-placeholder',
			type: 'inline',
		},
		// type: 'ajax',
		mainClass: 'mfp-faq-fade',
		enableEscapeKey: false,
		tLoading:
			'<div class="loading-wrapper"><img aria-hidden="true" alt="Loading" src="/image/loading-lg.gif"/></div>',
		callbacks: {
			beforeOpen() {
				previewEmailIsOpened = true
				$('#share-seat-popup').modal('hide')
			},
			afterClose() {
				previewEmailIsOpened = false
				$('#share-seat-popup').modal('show')
			},
			parseAjax(mfpResponse) {},
			ajaxContentAdded() {
				// Ajax content is loaded and appended to DOM
				// console.log(this.content);
			},
		},
	})
}

window.shareSeatPopup = shareSeatPopup
window.getSeatWidgetImage = getSeatWidgetImage
window.getSeatWidgetImageBv = getSeatWidgetImageBv
window.previewEmailPost = previewEmailPost
window.copyOnclick = copyOnclick
window.sendSeatSelectionsAction = sendSeatSelectionsAction
